import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { kJsonObject } from "../../../Admin/kReusableCoreTS/kJsonObject";
import { AppContact } from "./AppIndex";

// AppChatMarksRules - the pure half of `AppChatMarks` (habitat-free: `AppViews` and the Bridge suite import it).

export class AppChatMark {
    public ChatId: string = "";
    public PinnedAt: number = 0;
    public Unread: number = 0;
    public Locked: boolean = false;
    public Blocked: boolean = false;
}

export class AppChatMarksRules {
    public static readonly EveryMs: number = 30000;
    public static readonly MaxMarks: number = 5000;

    /** THE read's address: `GET /chat/settings?number=&view=marks` (the key goes in the Authorization header). "" = no service. */
    public static Url = (Base: string, Number: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (Base.length === 0 || Number.length === 0) { return ""; }
            return Base + "?number=" + encodeURIComponent(Number) + "&view=marks";
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppChatMarksRules.Url");
            return "";
        }
    };

    /** The answer's marks keyed by chat id; null = not an answer (kept: the last marks stay drawn). */
    public static Parse = (Status: number, Text: string): Map<string, AppChatMark> | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            const Doc: Record<string, unknown> | null = kJsonObject.ObjectOfJson(Text);
            if (Status < 200 || Status >= 300 || Doc === null || Doc.ok !== true || Array.isArray(Doc.marks) === false) { return null; }
            const Out: Map<string, AppChatMark> = new Map<string, AppChatMark>();
            for (const Raw of (Doc.marks as unknown[]).slice(0, AppChatMarksRules.MaxMarks)) {
                const One: AppChatMark | null = AppChatMarksRules.MarkOf(Raw);
                if (One !== null) { Out.set(One.ChatId, One); }
            }
            return Out;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppChatMarksRules.Parse");
            return null;
        }
    };

    /** DOCUMENTED EXCEPTION: strict reader of one mark; a malformed one is left out. */
    private static MarkOf = (Raw: unknown): AppChatMark | null => {
        if (Raw === null || typeof Raw !== "object") { return null; }
        const R: Record<string, unknown> = Raw as Record<string, unknown>;
        if (typeof R.chatId !== "string" || /^\d{5,20}@(s\.whatsapp\.net|lid)$/.test(R.chatId) === false) { return null; }
        const Out: AppChatMark = new AppChatMark(); Out.ChatId = R.chatId;
        if (typeof R.pinnedAt === "number" && Number.isSafeInteger(R.pinnedAt) && R.pinnedAt > 0) { Out.PinnedAt = R.pinnedAt; }
        if (typeof R.unread === "number" && Number.isSafeInteger(R.unread) && R.unread >= -1 && R.unread < 1000000) { Out.Unread = R.unread; }
        Out.Locked = R.locked === true; Out.Blocked = R.blocked === true;
        return Out;
    };

    /** Puts the marks on the rows (every row: a mark that went away clears). True = something changed (repaint). */
    public static Apply = (Rows: AppContact[], Marks: Map<string, AppChatMark>): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            let Changed: boolean = false;
            for (const Row of Rows) {
                let Mark: AppChatMark | undefined = Marks.get(Row.ChatId);
                if (Mark === undefined) { Mark = new AppChatMark(); }
                if (Row.PinnedAt !== Mark.PinnedAt || Row.PhoneUnread !== Mark.Unread || Row.Locked !== Mark.Locked || Row.Blocked !== Mark.Blocked) { Changed = true; }
                Row.PinnedAt = Mark.PinnedAt; Row.PhoneUnread = Mark.Unread; Row.Locked = Mark.Locked; Row.Blocked = Mark.Blocked;
            }
            return Changed;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppChatMarksRules.Apply");
            return false;
        }
    };

    /** The ONE badge count: the larger of WACommander's "N new" and the phone's count; -1 = "Unread" (marked, no count). */
    public static BadgeCount = (One: AppContact): number => {
        if (getCoreUtils().KErrorMode === true) { return 0; }
        try {
            const Most: number = Math.max(One.Unread, One.PhoneUnread);
            if (Most > 0) { return Most; }
            if (One.PhoneUnread === -1) { return -1; }
            return 0;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppChatMarksRules.BadgeCount");
            return 0;
        }
    };
}

